import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-430d7ca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-primary capitalize" }, "Empresas")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "my-2"
}
const _hoisted_5 = { class: "flex flex-col w-full" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-primary capitalize" }, "Unidades")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "my-2 ml-4"
}
const _hoisted_8 = { class: "flex flex-col w-full" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-primary capitalize" }, "Escalas")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "my-2 ml-8"
}
const _hoisted_11 = { class: "flex flex-col w-full" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-primary capitalize" }, "Posições/Cadeiras")
], -1))
const _hoisted_13 = {
  key: 0,
  class: "my-2 ml-12"
}

import { ref, reactive } from 'vue'
import ArrowIcon from '@/assets/icons/down.vue'
import PolicyDomainTab from './domain.tab.vue'
import DsPolicyDomainSkeleton from '@/components/designSystem/Skeleton/DsPolicyDomainSkeleton.vue'
import { useDsPolicyStore } from '@/pinia-store/useDsPolicyStore'
import { MappedDomainPolicy } from '@/types/domain'
import { useErrorToast } from '@/composables/useErrorToast'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { notifyError } = useErrorToast()

const DOMAIN_LOAD_ERROR: Record<string, string> = {
  empresa: 'Não foi possível carregar as empresas vinculadas à política de restrição.',
  unidade: 'Não foi possível carregar as unidades vinculadas à política de restrição.',
  escala: 'Não foi possível carregar as escalas vinculadas à política de restrição.',
  cadeira: 'Não foi possível carregar as posições vinculadas à política de restrição.'
}

const show = ref({
  empresa: false,
  unidade: false,
  escala: false,
  cadeira: false
})

const isLoading = reactive({
  empresa: false,
  unidade: false,
  escala: false,
  cadeira: false
})

const toggle = async (key: keyof typeof show.value) => {
  if (!show.value[key]) {
    // Sem catch aqui: `loadPoliciesByDomain` já captura e notifica (notifyError com
    // a mensagem do domínio) — um catch neste nível só duplicaria o log.
    try {
      isLoading[key] = true
      await loadPoliciesByDomain(key)
    } finally {
      isLoading[key] = false
      show.value[key] = !show.value[key]
    }
  } else {
    show.value[key] = !show.value[key]
  }
}

const policyStore = useDsPolicyStore()

const empresaPolicies = ref<MappedDomainPolicy[]>([])
const unidadePolicies = ref<MappedDomainPolicy[]>([])
const escalaPolicies = ref<MappedDomainPolicy[]>([])
const cadeiraPolicies = ref<MappedDomainPolicy[]>([])

const formatDate = (str: string) => {
  const date = new Date(str)
  return isNaN(date.getTime()) ? '-' : date.toLocaleString('pt-BR')
}

// eslint-disable-next-line complexity
const loadPoliciesByDomain = async (domainType: string) => {
  const policy = policyStore.currentPolicy
  if (!policy) return

  let domainList: any[] = []

  try {
    switch (domainType) {
      case 'empresa':
        domainList = (await policyStore.fetchCompanyDomain(policy.id))?.data || []
        break
      case 'unidade':
        domainList = (await policyStore.fetchHealthUnitDomain(policy.id))?.data || []
        break
      case 'escala':
        domainList = (await policyStore.fetchScheduleDomain(policy.id))?.data || []
        break
      case 'cadeira':
        domainList = (await policyStore.fetchPositionDomain(policy.id))?.data || []
        break
    }

    const mapped: MappedDomainPolicy[] = domainList.map((d) => ({
      id: d.id,
      local:
        d.company?.name ||
        d.healthUnit?.name ||
        d.schedule?.name ||
        d.position?.name ||
        'Desconhecido',
      startDate: formatDate(d.startDate),
      endDate: formatDate(d.endDate),
      vinculoDate: formatDate(d.createdAt),
      responsavel: d.linkedBy?.name || 'Desconhecido'
    }))

    if (domainType === 'empresa') empresaPolicies.value = mapped
    if (domainType === 'unidade') unidadePolicies.value = mapped
    if (domainType === 'escala') escalaPolicies.value = mapped
    if (domainType === 'cadeira') cadeiraPolicies.value = mapped
  } catch (e) {
    console.error(`Erro ao buscar domínio ${domainType}`, e)
    notifyError(
      e,
      DOMAIN_LOAD_ERROR[domainType] ??
        'Não foi possível carregar o domínio da política de restrição.'
    )
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle('empresa'))),
        class: _normalizeClass(["header-title mt-2", show.value.empresa ? 'rounded-b-none bg-gray-200' : ''])
      }, [
        _hoisted_3,
        _createVNode(ArrowIcon, {
          class: _normalizeClass(show.value.empresa ? 'rotate-180' : ''),
          color: "#000"
        }, null, 8, ["class"])
      ], 2),
      (show.value.empresa || isLoading.empresa)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (isLoading.empresa)
              ? (_openBlock(), _createBlock(DsPolicyDomainSkeleton, { key: 0 }))
              : (_openBlock(), _createBlock(PolicyDomainTab, {
                  key: 1,
                  policies: empresaPolicies.value
                }, null, 8, ["policies"]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggle('unidade'))),
        class: _normalizeClass(["header-title", show.value.unidade ? 'rounded-b-none bg-gray-200' : ''])
      }, [
        _hoisted_6,
        _createVNode(ArrowIcon, {
          class: _normalizeClass(show.value.unidade ? 'rotate-180' : ''),
          color: "#000"
        }, null, 8, ["class"])
      ], 2),
      (show.value.unidade || isLoading.unidade)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (isLoading.unidade)
              ? (_openBlock(), _createBlock(DsPolicyDomainSkeleton, { key: 0 }))
              : (_openBlock(), _createBlock(PolicyDomainTab, {
                  key: 1,
                  policies: unidadePolicies.value
                }, null, 8, ["policies"]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (toggle('escala'))),
        class: _normalizeClass(["header-title", show.value.escala ? 'rounded-b-none bg-gray-200' : ''])
      }, [
        _hoisted_9,
        _createVNode(ArrowIcon, {
          class: _normalizeClass(show.value.escala ? 'rotate-180' : ''),
          color: "#000"
        }, null, 8, ["class"])
      ], 2),
      (show.value.escala || isLoading.escala)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (isLoading.escala)
              ? (_openBlock(), _createBlock(DsPolicyDomainSkeleton, { key: 0 }))
              : (_openBlock(), _createBlock(PolicyDomainTab, {
                  key: 1,
                  policies: escalaPolicies.value
                }, null, 8, ["policies"]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (toggle('cadeira'))),
        class: _normalizeClass(["header-title", show.value.cadeira ? 'rounded-b-none bg-gray-200' : ''])
      }, [
        _hoisted_12,
        _createVNode(ArrowIcon, {
          class: _normalizeClass(show.value.cadeira ? 'rotate-180' : ''),
          color: "#000"
        }, null, 8, ["class"])
      ], 2),
      (show.value.cadeira || isLoading.cadeira)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (isLoading.cadeira)
              ? (_openBlock(), _createBlock(DsPolicyDomainSkeleton, { key: 0 }))
              : (_openBlock(), _createBlock(PolicyDomainTab, {
                  key: 1,
                  policies: cadeiraPolicies.value
                }, null, 8, ["policies"]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})